import { ResourcePageListFilterInput } from 'src/graphql/generated/graphql';
import { useTable } from 'src/hooks/use-table';
import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { TableWrapper } from 'src/components/common/wrapper/table/wrapper';
import { CreateResourceButton } from './create-resource-button';
import { FilterWrapper } from 'src/components/common/wrapper/filter/wrapper';
import { ResourceListFilter } from './filter';
import { Tabs } from '@otp/ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { ResourceListTable } from './list-table';
import { ResourcesIndexButton } from './resources-index-button';

interface ResourceListProps {
  isUserResources?: boolean;
  initialTab?: TabType;
}

export enum TabType {
  Resources = 'resources',
  Bookmarks = 'bookmarks',
}

export const ResourceList = ({
  isUserResources = false,
  initialTab = TabType.Resources,
}: ResourceListProps) => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState(initialTab);

  const TABS = [
    { label: t('common.resources'), value: TabType.Resources },
    { label: t('common.bookmarks'), value: TabType.Bookmarks },
  ];

  const onTabChange = (_: any, value: any) => {
    setActiveTab(value);
  };

  const isBookmarksView = activeTab === TabType.Bookmarks;

  const { filter, onFilterChange, defaultFilter } = useTable<
    ResourcePageListFilterInput,
    any
  >();

  return (
    <>
      <FilterWrapper>
        <ResourceListFilter
          onSubmit={onFilterChange}
          defaultFilter={defaultFilter}
          isUserResources={isUserResources}
        />
      </FilterWrapper>
      <ContentWrapper>
        <TableWrapper>
          {isUserResources && (
            <Tabs tabs={TABS} onChange={onTabChange} value={activeTab} />
          )}

          {!isBookmarksView && (
            <div className="flex justify-end mt-2">
              {!isUserResources && (
                <>
                  <CreateResourceButton />
                  <ResourcesIndexButton className='ml-2'/>
                </>
              )}
            </div>
          )}

          <ResourceListTable
            key={activeTab}
            filter={filter}
            isUserResources={isUserResources}
            isBookmarksView={isBookmarksView}
            excludeColumns={isUserResources ? ['status'] : []}
          />
        </TableWrapper>
      </ContentWrapper>
    </>
  );
};
